<template>
  <div class="suggest">
    <Card>
      <Card dis-hover :bordered="false" style="text-align: left">
        <Row type="flex" justify="start">
          <Col :span="12">
            <span>起止时间：</span>
            <DatePicker transfer type="datetime" placeholder="请选择起始时间" v-model="startTime"></DatePicker>
            <span> — </span>
            <DatePicker transfer type="datetime" placeholder="请选择结束时间" v-model="endTime"></DatePicker>
            <Button type="primary" @click="getSuggestedFeedbacksList" style="margin-left: 8px">查询</Button>
          </Col>
        </Row>
      </Card>
      <Table
          :loading="dataLoading"
          :columns="columns"
          :data="data"
          :border="false"
          :stripe="false"
          :highlight-current-row="true"
      >
        <template #action="{ row, index }">
          <el-button type="text" @click="gotoDetail(row)">查看</el-button>
        </template>
      </Table>
      <Page style="text-align: right;margin-top: 10px"
            show-sizer
            show-total
            transfer
            :total="dataTotal"
            :page-size="pageSize"
            :page-size-opts="pageSizeOpts"
            :current-page="currentPage"
            @on-change="pageChange"
            @on-page-size-change="pageSizeChange"
      ></Page>
    </Card>
  </div>
</template>

<script>
export default {
  name: "suggestFeedBack",
  data() {
    return {
      startTime: null,
      endTime: null,
      dataLoading: false,
      dataTotal: 0,
      columns: [
        // {
        //   title: 'openId',
        //   align: 'center',
        //   // width: '120',
        //   render: (h, params) => {
        //     return h('div', {
        //       style: {
        //         // textAlign: 'left'
        //       }
        //     }, params.row.openId)
        //   }
        // },
        {
          title: '联系电话',
          align: 'center',
          width: '150',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.mobile)
          }
        },
        {
          title: '反馈内容',
          align: 'center',
          // width: '120',
          render: (h, params) => {
            return h('div', {
              style: {
                // textAlign: 'left'
              }
            }, params.row.content)
          }
        },
        // {
        //   title: '图片',
        //   align: 'center',
        //   // width: '120',
        //   render: (h, params) => {
        //     return h('div', {
        //       style: {
        //         // textAlign: 'left'
        //       }
        //     }, params.row.img)
        //   }
        // },
        {
          width: '200',
          title: '操作',
          // fixed: 'right',
          align: 'center',
          slot: 'action',
        }
      ],
      data: [],
      pageSize: 10,
      pageSizeOpts: [10, 20, 30, 40],
      currentPage: 1,
      curUser: '',
    }
  },
  watch: {
    userInfo: {
      immediate: true,
      deep: true,
      handler(newVal) {
        if (newVal) {
          console.log(newVal)
          this.curUser = newVal.userId
        }
      }
    }
  },
  computed: {
    userInfo: {
      get: function () {
        return this.$store.state.user.userInfo
      },
      set: function () {
      }
    }
  },
  mounted() {
    this.getSuggestedFeedbacksList()
  },
  methods: {
    gotoDetail(row) {
      this.$router.push({
        name: 'suggestDetail',
        params: {
          row: row
        }
      })
    },
    getSuggestedFeedbacksList() {
      let params = {
        startTime: this.startTime === '' ? null : this.startTime,
        endTime: this.endTime === '' ? null : this.endTime,
        page: this.currentPage,
        size: this.pageSize
      }
      this.$http.post('/api/getSuggestedFeedbacksList', params).then(res => {
        console.log(res)
        this.data = res.data.data
        this.dataTotal = res.data.recordsTotal
      })
    },
    pageChange(page) {
      this.currentPage = page
      this.getSuggestedFeedbacksList()
    },
    pageSizeChange(pageSize) {
      this.pageSize = pageSize
      this.getSuggestedFeedbacksList()
    },
  }
}
</script>

<style scoped lang="less">
.suggest {
}
</style>
